//TODO: More event types can be added here.
const eventTitles = {
  "DOWNLOAD_STATUS": "Report Generated",
  "API_ERROR": "API Error",
}

export const getEventTitle = (type) => {
    return eventTitles[type] || type;
}
